import { NasaApodForm } from '@/features/factory/subfactories/NasaApodForm'

/** Sub-route /factory/nasa-apod — wraps the NASA APOD form. */
export function NasaApodPage() {
  return <NasaApodForm />
}
